<template>
  <div class="helpcontent">
    <top></top>
    <navMenu></navMenu>
    <div class="inner clearfix">
      <div class="fl nav">
        <el-row>
          <el-col>
            <el-menu
              :default-active="activeIndex"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @select="handleSelect"
            >
              <!-- <el-menu-item index="1">
                <i class="el-icon-menu"></i>
                <span>问题反馈</span>
              </el-menu-item> -->
              <el-menu-item index="2">
                <i class="el-icon-document"></i>
                <span>常见问题</span>
              </el-menu-item>
              <el-menu-item index="3">
                <i class="el-icon-location"></i>
                <span>关于我们</span>
              </el-menu-item>
              <!-- <el-submenu index="3">
                                <template slot="title">
                                    <i class="el-icon-location"></i>
                                    <span>关于我们</span>
                                </template>
                                    <el-menu-item index="3-1">孺教网APP</el-menu-item>
                                    <el-menu-item index="3-2">孺教网公众号</el-menu-item>
                            </el-submenu> -->
            </el-menu>
          </el-col>
        </el-row>
      </div>
      <div class="fr content">
        <feedback v-if="activeIndex == '1'"></feedback>
        <problem v-if="activeIndex == '2'"></problem>
        <app v-if="activeIndex == '3' || activeIndex == '3-1'"></app>
        <official v-if="activeIndex == '3-2'"></official>
      </div>
    </div>
  </div>
</template>

<script>
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
import feedback from "@/components/common/feedback.vue";
import problem from "@/components/common/problem.vue";
import app from "@/components/common/app.vue";
import official from "@/components/common/official.vue";
export default {
  components: {
    top,
    navMenu,
    feedback,
    problem,
    app,
    official,
  },
  data() {
    return {
      activeIndex: "2",
    };
  },
  mounted() {},
  methods: {
    handleOpen(key) {
      // console.log(key);
      this.activeIndex = key;
    },
    handleSelect(key) {
      // console.log(key);
      this.activeIndex = key;
    },
  },
};
</script>

<style lang='less' scoped>
.helpcontent {
  .nav {
    margin-top: 20px;
    background-color: #fff;
    width: 20%;
    padding: 20px 0;
  }
  .content {
    width: 78%;
    margin-top: 20px;
  }
}
</style>
